import { render, staticRenderFns } from "./storeSettlementConfiguration.vue?vue&type=template&id=11254389"
import script from "./storeSettlementConfiguration.vue?vue&type=script&lang=js"
export * from "./storeSettlementConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports